module.exports = "/_next/static/images/hero-section-cyber-7493cb9f6f75e0c01deb4736514c280b.webp";